import React from 'react';
import { contact, identity } from '../data/portfolio';
import { Label } from './Label';
const links = [{
  label: 'Email',
  value: contact.email,
  href: `mailto:${contact.email}`,
  external: false
}, {
  label: 'LinkedIn',
  value: contact.linkedin,
  href: contact.linkedinUrl,
  external: true
}];
export function Contact() {
  return <footer id="contact" className="scroll-mt-20 border-t border-white/10 bg-ink-900 px-6 py-20 md:px-10 md:py-24" data-id="element-82" data-mp="2w91mrpaa9qow">
      <div className="mx-auto w-full max-w-edge" data-id="element-83" data-mp="3szkdn1jzxfm1">
        <Label data-id="element-84" data-mp="3ox7ckqg725vl">Contact</Label>

        <ul className="mt-12 border-t border-white/15" data-id="element-85" data-mp="3oy8xrnqxc8r1">
          {links.map(link => <li key={link.label} className="border-b border-white/15" data-id="element-86" data-mp="3k3l7pkg9v6ac">
              <a href={link.href} target={link.external ? '_blank' : undefined} rel={link.external ? 'noreferrer' : undefined} className="flex flex-wrap items-baseline justify-between gap-x-8 gap-y-2 py-7 transition-colors duration-150 ease-editorial hover:text-brass focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-brass" data-id="element-87" data-mp="3f59z1d1pr1tp">
                <span className="text-[0.75rem] uppercase tracking-[0.3em] text-fog" data-id="element-88" data-mp="3b39bz3ovfj8l">
                  {link.label}
                </span>
                <span className="font-display text-xl text-paper transition-colors duration-150 ease-editorial hover:text-brass md:text-2xl" data-id="element-89" data-mp="3f3t8q65j8ku7">
                  {link.value}
                </span>
              </a>
            </li>)}
        </ul>

        <div className="mt-16 flex flex-col gap-3 text-[0.7rem] uppercase tracking-[0.24em] text-fog sm:flex-row sm:items-center sm:justify-between" data-id="element-90" data-mp="361tshg2cdksb">
          <span data-id="element-91" data-mp="2w6s0mcgom4m1">
            {identity.name} · {identity.role}
          </span>
          <span data-id="element-92" data-mp="qcsc29s75i3v">{identity.location}</span>
          <a href={contact.websiteUrl} className="text-brass transition-colors duration-150 ease-editorial hover:text-paper" data-id="element-93" data-mp="qdtmqd5aw2l2">
            {contact.website}
          </a>
          <span data-id="element-94" data-mp="239hfxhzambrq">© {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>;
}